import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransportDetailsDialogActionComponent } from './transport-details-dialog-action/transport-details-dialog-action.component';
import { CommonTranslationModule, CommonUIModule } from '@sdbn/common';

import { LinkTransportDialogActionComponent } from './link-transport-dialog-action/link-transport-dialog-action.component';
import { AttachDetachTransportDialogActionComponent } from './attach-detach-transport-dialog-action/attach-detach-transport-dialog-action.component';
import { ResendMessageActionComponent } from './resend-message-action/resend-message-action.component';
import { RegisterEntranceActionComponent } from './register-entrance-action/register-entrance-action.component';
import { RegisterEntranceLeaveModule } from '../register-entrance-leave/register-entrance-leave.module';
import { MatTooltipModule } from '@angular/material/tooltip';


@NgModule({
  declarations: [
    TransportDetailsDialogActionComponent,
    LinkTransportDialogActionComponent,
    AttachDetachTransportDialogActionComponent,
    ResendMessageActionComponent,
    RegisterEntranceActionComponent
  ],
  imports: [
    CommonModule,
    CommonTranslationModule,
    MatTooltipModule,
    RegisterEntranceLeaveModule,

    CommonUIModule
  ],
  exports: [
    TransportDetailsDialogActionComponent,
    LinkTransportDialogActionComponent,
    AttachDetachTransportDialogActionComponent,
    ResendMessageActionComponent,
    RegisterEntranceActionComponent
  ]
})
export class ActionsModule { }
